export default __webpack_public_path__ + "static/media/meal.c90fc0de.mp4";